import model from "../model";
import { fetchResource } from "../services/web-res-service"
import type { ClientConfigData } from "../types/client-config-types";
import { addDirPath } from "../utils/utils";

export default {
    init: async () => {
        const resources: Partial<Record<keyof ClientConfigData, string>> = {
            nav: addDirPath(model.cmResBase || '', 'nav.json'),
            gameProviders: addDirPath(model.cmResBase || '', 'providers.json'),
        };

        const requests: Promise<any>[] = [];

        for(const key in resources){
            const typedKey = key as keyof typeof resources;

            const val = resources[typedKey];
            if(!val) continue;

            requests.push(fetchResource(val, {showErrorMsg: false, retryOnResourceProblem: true}));
        }

        const responses = await Promise.all(requests);

        let c = 0;
        for(const key in resources){
            const typedKey = key as keyof typeof resources;
            model.clientConfig[typedKey] = responses[c];
            c++;
        }
    },
}